import Hardware from './Hardware';
import installer from './Installer';
import integrations from './Integrations';

const subRoutes = [installer, integrations];

export default {
  title: 'Hardware',
  path: '/hardware',
  component: Hardware,
  rootPath: { name: 'Hardware' },
  subRoutes,
};
